// Tost u dołu ekranu (WYGLAD.md #6): krótki komunikat po prostej akcji („Zapisano.”) zamiast napisów w treści;
// „Cofnij” tylko przy akcjach prostych do odwrócenia (ukrycie karty, pozycje zakupów, przeczytane alarmy) -
// nieodwracalne nadal z oknem potwierdzenia. Jeden naraz, nowy zastępuje stary; rysuje go powłoka.
import { useSyncExternalStore } from "react";

export interface DaneTostu {
  id: number;
  tekst: string;
  akcja?: { etykieta: string; onKliknij: () => void };
}

const ZWYKLY_MS = 4000;
const Z_AKCJA_MS = 7000; // czas na „Cofnij”

let biezacy: DaneTostu | null = null;
let licznik = 0;
let zegar = 0;
const sluchacze = new Set<() => void>();
const powiadom = () => { for (const f of sluchacze) f(); };

export function pokazTost(tekst: string, akcja?: DaneTostu["akcja"]): void {
  window.clearTimeout(zegar);
  const id = ++licznik;
  biezacy = { id, tekst, akcja: akcja && { ...akcja, onKliknij: () => { schowajTost(); akcja.onKliknij(); } } };
  powiadom();
  zegar = window.setTimeout(schowajTost, akcja ? Z_AKCJA_MS : ZWYKLY_MS);
}

export function schowajTost(): void {
  if (!biezacy) return;
  biezacy = null;
  powiadom();
}

export function useTost(): DaneTostu | null {
  return useSyncExternalStore((f) => { sluchacze.add(f); return () => sluchacze.delete(f); }, () => biezacy);
}
